import { render, staticRenderFns } from "./emailReceiversGroupDialog.vue?vue&type=template&id=dc8148ce&scoped=true&"
import script from "./emailReceiversGroupDialog.vue?vue&type=script&lang=js&"
export * from "./emailReceiversGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8148ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
